import { Container, Grid, Typography } from "@mui/material";
import { Image } from "../../../fe-ui/atoms/Image";
import { ContentRenderer } from "./ContentRenderer";

export function ContentRendererZigZagList(block: any) {
  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      {block.items.map((block, index) => {
        const direction = index % 2 === 0 ? "row" : "row-reverse";
        return (
          <Grid direction={direction} container spacing={2} key={block.id} my={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant={"h3"}>{block.title}</Typography>
              <ContentRenderer
                content={block.text}
                __component="static-pages.paragraph"
              />
            </Grid>
            <Grid item xs={12} sm={6} p={4}>
              <Image
                draggable={false}
                sx={{ borderRadius: 2 }}
                src={block.media.data.attributes.formats.thumbnail.url}
              />
            </Grid>
          </Grid>
        );
      })}
    </Container>
  );
}
